import { yupResolver } from "@hookform/resolvers/yup";
import { AlertColor } from "@mui/material";
import { useEffect, useState } from "react";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";

import ButtonGeneric from "../../components/ButtonGeneric";
import InputGeneric from "../../components/InputGeneric";
import PageWrapper from "../../components/PageWrapper/index";
import PreloadButton from "../../components/PreloadButton";
import Toast from "../../components/Toast";
import { useAuth } from "../../contexts/contexts";
import { api } from "../../services/api";
import { FormGraceDayRegisterPage } from "./styles";

type leadSourceFormTypeValues = {
    days: string;
};

const leadSourceFormSchema = yup.object().shape({
    days: yup.string().required(),
});

function GraceDayRegisterPage() {
    const navigate = useNavigate();
    const { hasPermissions, permissions } = useAuth();
    useEffect(() => {
        if (
            hasPermissions("dias.carencia.cadastrar") === false &&
            permissions.length > 0
        ) {
            navigate("/Error");
        }
    }, [permissions]);

    const {
        handleSubmit,
        control,
        formState: { errors },
    } = useForm<leadSourceFormTypeValues>({
        resolver: yupResolver(leadSourceFormSchema),
    });

    // toast configs
    const [openToast, setOpenToast] = useState(false);
    function handleCloseToast() {
        setOpenToast(false);
    }
    const [toastRequisitionResult, setToastRequisitionResult] =
        useState<AlertColor>();
    const [textToast, setTextToast] = useState("");

    const [isLoadingButton, setIsLoadingButton] = useState(false);

    const createNewHolderType: SubmitHandler<leadSourceFormTypeValues> = async (
        formValues
    ) => {
        setIsLoadingButton(true);
        api.post(`/graceDay`, {
            days: formValues.days,
        })
            .then((response) => {
                setOpenToast(true);
                setToastRequisitionResult("success");
                setTextToast(response.data.message);
            })
            .then(() => {
                setTimeout(() => {
                    navigate("/settings/graceDays");
                    setOpenToast(false);
                    setIsLoadingButton(false);
                }, 2000);
            })
            .catch((response) => {
                setOpenToast(true);
                setToastRequisitionResult("error");
                setTextToast(response.response.data.response.name);
                setIsLoadingButton(false);
            });
    };

    return (
        <PageWrapper>
            <FormGraceDayRegisterPage>
                <div className="topFormPage">
                    <h2>Cadastrar Novo Período de Carência</h2>
                </div>
                <form onSubmit={handleSubmit(createNewHolderType)}>
                    <div className="inputsContainer">
                        <Controller
                            control={control}
                            name="days"
                            render={({
                                field: { onChange, onBlur, value = "", ref },
                            }) => (
                                <InputGeneric
                                    onChange={onChange}
                                    onBlur={onBlur}
                                    value={value}
                                    size="small"
                                    type="number"
                                    className="inputs"
                                    label="Dias"
                                    error={!!errors.days}
                                    ref={ref}
                                    autoFocus
                                />
                            )}
                        />
                    </div>
                    <div className="buttonsContainer">
                        <ButtonGeneric
                            onclick={() => navigate("/settings/graceDays")}
                            buttonColor="var(--cancel)"
                            text="VOLTAR"
                        />
                        <PreloadButton
                            colorText="white"
                            background="var(--confirm)"
                            loading={isLoadingButton}
                            text="CONFIRMAR"
                            type="submit"
                        />
                    </div>
                </form>
                <Toast
                    open={openToast}
                    onClose={() => handleCloseToast()}
                    severity={toastRequisitionResult}
                    text={textToast}
                />
            </FormGraceDayRegisterPage>
        </PageWrapper>
    );
}
export default GraceDayRegisterPage;
